/*
  "Vedi ancora": aggiunge la pagina successiva in fondo alla griglia, invece di mandare il
  cliente su un'altra pagina.

  Perche': con 43.000 pezzi il salto di pagina e' il punto in cui si smette di guardare — si
  perde il posto nella griglia e si torna in cima. La pagina 3 non la apre quasi nessuno.

  Come: si chiede la pagina successiva, si prende la sua griglia (#product-grid) e si attaccano
  i suoi figli a quella che c'e' gia'. Nessuna API, nessun template nuovo: e' la stessa pagina
  che Shopify servirebbe comunque.

  L'URL NON si riscrive con ?page=N. Se lo si facesse, un ricaricamento ripartirebbe da quella
  pagina e tutto quello che si era gia' scorso sparirebbe.

  La paginazione classica resta nel markup e la si nasconde qui: senza JavaScript, e per chi
  indicizza il sito, il catalogo deve restare percorribile pagina per pagina.
*/
(function () {
  const zona = document.querySelector('[data-mc-ancora]');
  if (!zona) return;
  // da qui in poi il JS c'e': la paginazione a numeri diventa ridondante
  document.querySelectorAll('.mc-paginazione').forEach((e) => { e.hidden = true; });

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-mc-prossima]');
    if (!b) return;
    e.preventDefault();
    const url = b.getAttribute('data-mc-prossima');
    if (!url || b.dataset.carico === '1') return;

    b.dataset.carico = '1';
    b.disabled = true;
    const etichetta = b.textContent;
    b.textContent = 'Carico…';

    try {
      const r = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      /**
       * Dove attaccare le schede. Nelle COLLEZIONI `#product-grid` e' gia' la <ul> delle
       * schede; nella RICERCA e' un <div> contenitore con la <ul> dentro (e un overlay di
       * caricamento). Attaccare ai figli di `#product-grid` senza guardare produceva, sulla
       * ricerca, una SECONDA lista appesa alla prima invece che schede unite.
       */
      const lista = (r) => (r ? (r.matches('ul') ? r : r.querySelector('ul.product-grid, ul')) : null);
      const nuova = lista(doc.getElementById('product-grid'));
      const attuale = lista(document.getElementById('product-grid'));
      if (nuova && attuale) {
        for (const li of Array.from(nuova.children)) {
          // via l'animazione a cascata di Dawn: e' pensata per il primo disegno della pagina,
          // riapplicata a meta' griglia fa comparire i prodotti nuovi con un ritardo strano
          li.removeAttribute('data-cascade');
          li.style.removeProperty('--animation-order');
          attuale.appendChild(li);
        }
      }
      const prossima = doc.querySelector('[data-mc-prossima]')?.getAttribute('data-mc-prossima');
      if (prossima) {
        b.setAttribute('data-mc-prossima', prossima);
        b.disabled = false;
        b.textContent = etichetta;
        b.dataset.carico = '0';
      } else {
        zona.remove();   // finito il catalogo: il bottone non serve piu'
      }
      // i cuori appena arrivati devono sapere se quel prodotto e' gia' salvato
      document.dispatchEvent(new CustomEvent('mc:ridisegna'));
    } catch (err) {
      // se la rete cade il bottone deve tornare premibile, non restare a "Carico…" per sempre
      b.disabled = false;
      b.textContent = etichetta;
      b.dataset.carico = '0';
    }
  });
})();
